/**
 * Step 5: Call Tunnel Validation API
 * If width/height errors exist, increase tunnel sizes
 * Only validates tunnels that have a fan (once per tunnel)
 */
import { IBotTunnel } from '../../../../models';
import { validateAndFixTunnelDimensions } from '../utils/tunnelValidation.utils';

export async function step5ValidateAndFixTunnels(
  tunnels: any[],
  tunnelIds: number[],
  botTunnels: IBotTunnel[],
  for_fans: boolean,
  getOptions: () => { signal?: AbortSignal },
  onProgress?: (coefficient: number) => void,
): Promise<any[]> {
  let updatedTunnels = [...tunnels];

  for (let i = 0; i < updatedTunnels.length; i++) {
    // Only validate if fan exists for this tunnel
    if (!botTunnels[i].sections.find((s) => s.type === 'fan') && for_fans) {
      continue;
    }

    try {
      const { updatedTunnel } = await validateAndFixTunnelDimensions(
        tunnelIds[i],
        getOptions,
        onProgress,
        updatedTunnels[i], // Pass current tunnel from array
      );

      // Update tunnel data if it was updated, otherwise keep current tunnel from array
      if (updatedTunnel) {
        updatedTunnels[i] = updatedTunnel;
      }
    } catch (e) {
      // Ignore validation errors, continue
    }
  }

  return updatedTunnels;
}
